import styled from 'styled-components';

import { IconButton, minWidth, Text } from '@calm-web/design-system';

export const Wrapper = styled.section`
	margin: 0 auto;
	max-width: 1440px;
	padding: 60px 24px;
	text-align: center;

	${minWidth('desktop')} {
		padding: 100px 136px;
	}
`;

export const Heading = styled(Text).attrs({
	color: 'bannerText',
	el: 'h2',
	noMargin: true,
})`
	&&& {
		font-size: 24px;
		line-height: 1.5;
		margin-bottom: 32px;

		${minWidth('tablet')} {
			font-size: 31.5px;
			margin-bottom: 40px;
		}
	}
`;
export const VideoThumnbail = styled.div`
	align-items: center;
	aspect-ratio: 2.14;
	border-radius: 20px;
	display: flex;
	justify-content: center;
	overflow: hidden;
	position: relative;
	width: 100%;
`;
export const PlayButton = styled(IconButton)`
	&&& {
		align-items: center;
		background: rgba(0, 0, 0, 0.2);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		height: 64px;
		width: 64px;

		& > div,
		& svg {
			height: 36px;
			width: 36px;
		}
	}
`;
